import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=db91f9b2&scoped=true&"
import script from "./TaskRow.vue?vue&type=script&lang=js&"
export * from "./TaskRow.vue?vue&type=script&lang=js&"
import style0 from "./TaskRow.vue?vue&type=style&index=0&id=db91f9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db91f9b2",
  null
  
)

export default component.exports